// extracted by mini-css-extract-plugin
module.exports = {"messageWrapper":"style__messageWrapper__pDdy1"};